import { render, staticRenderFns } from "./AgentBillTableItem.vue?vue&type=template&id=010e0b8a&"
import script from "./AgentBillTableItem.vue?vue&type=script&lang=ts&"
export * from "./AgentBillTableItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports